import axios from 'axios'
import { toSnakeCase } from 'src/helpers/objectUtils'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(
  async (request) => {
      const token = localStorage.getItem('USER_TOKEN')
    if (token) {
      request.headers['Auth-Token'] = token
    } else {
      delete request.headers['Auth-Token']
    }
    request.data = toSnakeCase(request.data, ['base64_file'])
    request.params = toSnakeCase(request.params, ['base64_file'])

    return request
  },
  (errData) => {
    return errData
  },
)

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (errData) => {
    const status = errData?.response?.status
    const path = window.location.pathname

    const isPublicPage =
      path.startsWith('/qrdownload') ||
      path === '/login' ||
      path === '/register'

    if (status === 401 && !isPublicPage) {
      window.location.href = '/login'
    }

    return Promise.reject(errData)
  },
)

export { axiosInstance }
